import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { Subscription } from 'rxjs';
import { environment } from 'environments/environment';
@Component({
  selector: 'offline-error-banner',
  styleUrls: ['./offline-error-banner.style.scss'],
  templateUrl: './offline-error-banner.template.html'
})
export class OfflineErrorBanner implements OnInit, OnDestroy {

  isOnline: boolean = false;
  networkStatusSubscription: Subscription;
  showBanner: boolean = false;
  bannerMessage: any;
  bannerAnnimation: any;
  // fallback in case modal is to be centered w.r.t page and not screen.
  // this variable tracks if toc is open or not, use this to center align the modal
  @Input() isTocActive;
  // this variable tracks if toc is on left side or right side, use this to center respectively
  @Input() tocPosition;

  constructor(
    private networkService: NetwordDetectionService
  ) { }

  ngOnInit() {
    this.networkService.isOnline().then(result => (this.isOnline = result));
    this.networkStatusSubscription = this.networkService.monitorStatus().subscribe(async (isOnline) => {
      if (this.isOnline != isOnline) {
        this.isOnline = isOnline;
        this.showBannerAnimation();
      }
    });

  }

  async showBannerAnimation() {
    if (environment.isDesktopApp) {
      this.showBanner = true;
      clearTimeout(this.bannerAnnimation);
      this.bannerAnnimation = setTimeout(() => {
        this.showBanner = false;
      }, 10000);
    }

  }

  ngOnDestroy(): void {
    this.networkStatusSubscription.unsubscribe();
  }
  
}